import { render, staticRenderFns } from "./signaturePop.vue?vue&type=template&id=ebcd64fa"
import script from "./signaturePop.vue?vue&type=script&lang=js"
export * from "./signaturePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebcd64fa')) {
      api.createRecord('ebcd64fa', component.options)
    } else {
      api.reload('ebcd64fa', component.options)
    }
    module.hot.accept("./signaturePop.vue?vue&type=template&id=ebcd64fa", function () {
      api.rerender('ebcd64fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/result/signaturePop.vue"
export default component.exports